// src/Redux/subcategorySlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  subcategories: [],
  isLoaded: false,
};

const subcategorySlice = createSlice({
  name: "subcategory",
  initialState,
  reducers: {
    setSubcategories: (state, action) => {
      state.subcategories = action.payload;
      state.isLoaded = true;
    },
  },
});

export const { setSubcategories } = subcategorySlice.actions;
export default subcategorySlice.reducer;
